<script>
import * as moment from 'moment'

export default {
  data: () => ({
    date: moment().format('YYYY-MM-DD'),
  }),

  computed: {
    validationError() {
      if (!this.date) return 'Please choose a Placed Date';

      return undefined;
    },

    submitPayload() {
      return {};
    },
  },

  methods: {
    clearForm() {
      this.date = moment().format('YYYY-MM-DD');
    },

    async onFormSubmitSuccess(record) {
      this.clearForm();
      this.$emit('added', record);
    },

    onCancelledForm() {
      this.$router.push({ name: 'form-cancelled' });
    },
  },
}
</script>

<template>

  <div>
    <api-form
      method="post"
      :url="`v1/sales/egg-orders/${encodeURIComponent(date)}`"
      :payload="submitPayload"
      submit-text="Create Order"
      :validation-error="validationError"
      @success="onFormSubmitSuccess"
      @cancel="onCancelledForm">

      <h4 class="text-center mt-0">New Order</h4>

      <b-form-group label="Date" :label-for="`date-${_uid}`">
        <b-form-input :id="`date-${_uid}`" v-model="date" type="date" placeholder="Date..." required></b-form-input>
      </b-form-group>

    </api-form>

  </div>
</template>



// WEBPACK FOOTER //
// src/sales/components/EggOrderAdd.vue